import { EntityService } from './EntityService';
import { ICADefElement, IEntity } from '../types';

export class CADefElementService extends EntityService<ICADefElement> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CADefElements`);
    }

    public readAllDefElement(defElementGroupId: number): Promise<ICADefElement[]> {
        return this.readAll(`?$filter=DefElementGroupId eq ${defElementGroupId}`);
    }

    public readAllWithArgs(periodId: number): Promise<ICADefElement[]> {
        return this.readAll(`?$filter=PeriodId eq ${periodId}`);
    }

    public readAllForList2(periodId: number | string, formId: number): Promise<IEntity[]> {
        return this.readAll(`?periodId=${periodId}&formId=${formId}`);
    }

    public readAllDefElementsForPeriod(periodId: number, formId?: number): Promise<ICADefElement[]> {
        const defElementSelectFields = [
            'SectionAQuestion1',
            'SectionAQuestion2',
            'SectionAQuestion3',
            'SectionAQuestion4',
            'SectionAQuestion5',
            'SectionAQuestion6',
            'SectionAQuestion7',
            'SectionAQuestion8',
            'SectionAQuestion9',
            'SectionAQuestion10'
        ].join(',');

        const caElementSelectFields = [
            'ResponseA1',
            'ResponseA2',
            'ResponseA3',
            'ResponseA4',
            'ResponseA5',
            'ResponseA6',
            'ResponseA7',
            'ResponseA8',
            'ResponseA9',
            'ResponseA10'
        ].join(',');

        return this.readAll(
            `?$filter=PeriodId eq ${periodId}` +
            `&$select=${defElementSelectFields}` +
            `&$expand=CAElements(` +
            `$select=${caElementSelectFields}` +
            (formId ? `;$filter=FormId eq ${formId}` : '') +
            `)`
        );
    }



}